export enum AccessLevel {
    List = 0,
    Edit,
    Manage
}
